var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhois(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 45,
    viewBox: "0 0 44 45",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 9.63737,
    x2: 42.37,
    y1: 34.9379,
    y2: -1.15381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4312a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25638,
    stopColor: "#6233df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#849bff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.4565 10c-4.013 0-7.5157 2.1913-9.3983 5.4348h2.6537c.9782-1.2087 2.2548-2.1653 3.7406-2.7153-.3402.7913-.6129 1.7153-.8216 2.7153h2.2355c.5207-2.1489 1.2499-3.2609 1.5901-3.2609s1.0695 1.112 1.5901 3.2609h2.2355c-.2087-1-.4825-1.924-.8216-2.7153 1.4848.55 2.7624 1.5066 3.7407 2.7153h2.6537c-1.8826-3.2435-5.3853-5.4348-9.3984-5.4348zm-11.9565 7.6087 1.3502 6.5217h1.4224l.9235-3.7725.9213 3.7725h1.4161l1.3502-6.5217h-1.6347l-.5838 3.6579-.8683-3.6579h-1.2101l-.8704 3.6642-.5775-3.6642zm8.2647 0 1.3502 6.5217h1.4224l.9235-3.7725.9213 3.7725h1.416l1.3503-6.5217h-1.6326l-.5859 3.6579-.8662-3.6579h-1.2122l-.8683 3.6642-.5796-3.6642zm8.2647 0 .898 4.3351c.35-.4609.7584-.8734 1.2356-1.2016l-.4947-3.1335zm3.0868 0-.7091 2.9912c.7217-.4434 1.5522-.7149 2.4457-.7791l-.5265-2.2121zm2.6622 0-.3503 2.193c.5152.0174 1.007.1164 1.4754.2675l.5095-2.4605zm-.5393 4.3478c-2.2239 0-3.2608 1.9457-3.2608 3.2609h2.1739c0-.1794.1891-1.087 1.0869-1.087 1.075 0 1.087 1.0761 1.087 1.087 0 1.1456-2.1739 3.288-2.1739 4.3478h2.1739c0-1.0717 2.1739-2.8022 2.1739-4.3478 0-1.6033-1.2196-3.2609-3.2609-3.2609zm-19.1809 4.3478c1.8826 3.2435 5.3853 5.4348 9.3983 5.4348 2.4555 0 4.7075-.8359 6.526-2.2163.0109-.7522.2964-1.4445.6942-2.1315h-.6984-.8386c-.7837.6913-1.6792 1.2577-2.6792 1.6283.3391-.7913.6108-1.7153.8195-2.7153h-2.2355c-.5207 2.149-1.2499 3.2609-1.5901 3.2609s-1.0673-1.1119-1.588-3.2609h-2.2355c.2087 1 .4825 1.924.8216 2.7153-1.4848-.55-2.7624-1.5066-3.7406-2.7153zm18.094 5.4348v2.1739h2.1739v-2.1739z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhois);
export default __webpack_public_path__ + "static/media/whois.c2d09bc8b958cbfdee6767dcb81356f5.svg";
export { ForwardRef as ReactComponent };